
export type ChatRoomListResponsePageAllOfThreeContentItemLastMessageBasicInfoAllOfTwoType = typeof ChatRoomListResponsePageAllOfThreeContentItemLastMessageBasicInfoAllOfTwoType[keyof typeof ChatRoomListResponsePageAllOfThreeContentItemLastMessageBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatRoomListResponsePageAllOfThreeContentItemLastMessageBasicInfoAllOfTwoType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  FILE: 'FILE',
  LINK: 'LINK',
} as const;
